import { Map as ImmutableMap, Record } from 'immutable';

import type { QcsSyncResourceStore, QcsSyncResourceStoreProps } from '../core/resourceStoreTypes';
import type { HousingSelectionType } from '../housing-selection/housingSelectionTypes';

export const HOUSESTATS_REDUCER_KEY = 'zillowHouseStatsStore';

export type HouseStore = QcsSyncResourceStore<HousingSelectionType>;

export const mkHouseStore = Record<QcsSyncResourceStoreProps<HousingSelectionType>>({
  resourcesById: ImmutableMap(),
  loadPending: true,
  isLoading: false,
});

export type ZillowSubmittingObject = {
  manualAccount: boolean;
  scope: string;
  accountNameQCS: string;
  amount: number;
  link: string;
  businessId?: string;
};

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [HOUSESTATS_REDUCER_KEY]: HouseStore;
  }
}
// ////////////////////////////////////////////////////////////////////////////////////////////////
// RealEstate - Base RealEstate Properties
// ////////////////////////////////////////////////////////////////////////////////////////////////
